export const introduce = {
  text: `### 使用方法
  + 我们会在Delta指标附近到达顶部，红色区域是我们值得关注的区域

  ### 指标原理
  + 该指标通过以实现价格计算得出
  + 如果想对该指标有更深入的了解，可以参考 [比特币 Delta 资本化](https://medium.com/@kenoshaking/bitcoin-delta-capitalization-1d51a7b256b4)
  
  ### 创作者
  该指标由 [David Puell](https://twitter.com/kenoshaking) 创建`,
  height: 1450,
};
